export default __webpack_public_path__ + "2b64a59e4190636516f255a1240b5cce.png";